/* ── ivoltaa-products.js ── */

function ivSwitchTab(tab, sectionId) {
  var suffix = sectionId ? '-' + sectionId : '';

  /* Tab buttons */
  document.querySelectorAll('[data-section="' + sectionId + '"].iv-tab').forEach(function(t) {
    t.classList.remove('iv-tab--active');
  });
  var activeBtn = document.querySelector('[data-tab="' + tab + '"][data-section="' + sectionId + '"]');
  if (activeBtn) activeBtn.classList.add('iv-tab--active');

  /* Grids */
  var eth = document.getElementById('iv-tab-ethernet' + suffix);
  var tc  = document.getElementById('iv-tab-typec' + suffix);
  if (eth) eth.classList.toggle('iv-hidden', tab !== 'ethernet');
  if (tc)  tc.classList.toggle('iv-hidden', tab !== 'typec');

  /* Heading */
  var title = document.getElementById('iv-products-title' + suffix);
  var more  = document.getElementById('iv-view-more' + suffix);

  /* Read labels + URLs from data attributes set on the section */
  var section = document.getElementById('iv-products' + suffix);
  if (title && section) {
    title.textContent = tab === 'ethernet'
      ? (section.dataset.ethTitle || 'Ethernet Cables')
      : (section.dataset.tcTitle  || 'Type-C Cables');
  }
  if (more && section) {
    more.textContent = tab === 'ethernet'
      ? (section.dataset.ethMoreLabel || 'View all ethernet cables →')
      : (section.dataset.tcMoreLabel  || 'View all Type-C cables →');
    more.href = tab === 'ethernet'
      ? (section.dataset.ethMoreUrl || '#')
      : (section.dataset.tcMoreUrl  || '#');
  }
}

/* ── Add to Cart — Shopify AJAX ── */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.iv-pcard__atc').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = btn.dataset.id;
      if (!variantId) return;
      var orig = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = '✓ Added';
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.querySelectorAll('.cart-count, .cart__count, [data-cart-count]').forEach(function(el) {
              el.textContent = cart.item_count;
            });
          });
        setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 1800);
      })
      .catch(function() {
        btn.textContent = 'Error — try again';
        setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 2000);
      });
    });
  });
});